import { useEffect } from 'react';
import { appBackendApi } from '../../../app/appBackendApi';
import useSessionStore from '../../../stores/useSessionStore';
import useNodesProjectStore from '../stores/useNodesProjectStore';
import useNodesUiStore from '../stores/useNodesUiStore';
import useNodesFeedStore from '../stores/useNodesFeedStore';


export function useNodesRouteBootstrap(projectId, ruleId) {
  const userId = useSessionStore((s) => s.user?.id);

  useEffect(() => {
    const projectStore = useNodesProjectStore.getState();
    const uiStore = useNodesUiStore.getState();
    const feedStore = useNodesFeedStore.getState();

    projectStore.reset();
    uiStore.reset();
    feedStore.reset();

    const roles = appBackendApi.user?.roles ?? [];
    projectStore.init(appBackendApi, roles, projectId, ruleId);

    let cancelled = false;

    void (async () => {
      if (projectId) {
        await projectStore.loadProject(projectId);
      }
      if (cancelled) return;
      await projectStore.fetchFeedTypes();
    })();

    return () => {
      cancelled = true;
      useNodesProjectStore.getState().reset();
      useNodesUiStore.getState().reset();
      useNodesFeedStore.getState().reset();
    };
  }, [projectId, ruleId, userId]);
}
